
import {clearOnboardingData} from "../onboarding/actions";
import {tdaClear} from "../tda/actions";
import {logout} from "../login/login/actions";
import {emailClear} from "../inbox/actions";
import {clearUserDashboard} from "../dashboard/user/actions";
import {ClearChats} from "../chat/actions";
import {dwollaClear} from "../payment/actions";
import {clearPayments} from "../superadmin/payments-reducer";
import {securityClear} from "../superadmin/security-purchase-reducer";
import {clearUserPayments} from "../components/PaymentsDashboard/action";

/**
 * A single action to logout the user
 */

const dispatch_logout = dispatch => {
  dispatch(logout());
  dispatch(clearOnboardingData());
  dispatch(tdaClear());
  dispatch(dwollaClear());
  dispatch(emailClear());
  dispatch(clearUserDashboard());
  dispatch(ClearChats());
  dispatch(clearPayments());
  dispatch(securityClear());
  dispatch(clearUserPayments());
};

export { dispatch_logout };
